module.exports = __webpack_public_path__ + "close.png?e41a09d2885f7db750744e56daf24bd5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = 46
// module chunks = 0